module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "theme public skin--",
    class: _vm.themeNs
  }, [_c('keep-alive', [_c(_vm.layout, {
    tag: "component",
    staticClass: "layout"
  }, [_c(_vm.module(), {
    tag: "component",
    staticClass: "module",
    class: _vm.className
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38fc2866","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Layouts/shell/public.vue
// module id = viRL
// module chunks = 13 14